import { render } from "./Oekologie.vue?vue&type=template&id=6d68c9c8&scoped=true&ts=true"
import script from "./Oekologie.vue?vue&type=script&lang=ts"
export * from "./Oekologie.vue?vue&type=script&lang=ts"

import "./Oekologie.vue?vue&type=style&index=0&id=6d68c9c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d68c9c8"]])

export default __exports__